import React from "react";

const MobileAppThree = () => {
  return (
    <svg
      width="36"
      height="45"
      viewBox="0 0 36 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 11.5306V32.5917C35 41.0161 32.875 43.1222 24.375 43.1222H11.625C3.125 43.1222 1 41.0161 1 32.5917V11.5306C1 3.10611 3.125 1 11.625 1H24.375C32.875 1 35 3.10611 35 11.5306Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M22.2656 8.37244H13.7656"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M17.993 37.0134C19.8121 37.0134 21.2867 35.5519 21.2867 33.749C21.2867 31.9461 19.8121 30.4845 17.993 30.4845C16.1739 30.4845 14.6992 31.9461 14.6992 33.749C14.6992 35.5519 16.1739 37.0134 17.993 37.0134Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MobileAppThree;
